import { isNumber } from 'lodash';
import { getFiltersByIds } from '@src/api/filters';
import { type SavedFilter } from '@src/components/filter/components';

export interface Filter {
  presetFid?: string;
  fid?: number;
  name: string;
  rule: SavedFilter['rule'];
  rule_text?: SavedFilter['rule_text'];
}

// For ad-hoc filter, should skip the merging with latest filter
// For saved filter, should merge with matched latest filter
export const mergeWithRemoteFilters = (originalFilters: Filter[], remoteFilters: SavedFilter[]) => {
  // Empty filters will skip merging
  if (!originalFilters || !originalFilters.length) return originalFilters;

  // Empty latest filters will also skip merging
  if (!remoteFilters || !remoteFilters.length) return originalFilters;

  const newFilters = originalFilters.map((f) => {
    // For Ad-hoc filter skip the merging
    if (!isNumber(f.fid)) return f;

    // For saved filter merge with remote filter to update the rule and name
    const targetFilter = remoteFilters.find((it) => it.fid === f.fid);
    if (targetFilter) {
      const newF = {
        ...f,
        rule: targetFilter.rule,
        name: targetFilter.name,
      };
      if ('rule_text' in f) {
        newF.rule_text = targetFilter.rule_text;
      }
      return newF;
    }
    return f;
  });
  return newFilters;
};

export const getRemoteFilters = async (filterIds: number[]): Promise<SavedFilter[]> => {
  try {
    // filter id checking
    const validFids = (filterIds || []).filter((id) => isNumber(id));
    if (!validFids.length) return [];

    const remoteFilters = await getFiltersByIds<SavedFilter[]>(validFids);
    return remoteFilters;
  } catch (e) {
    /* do nothing */
  }

  return [];
};
